import { useState } from "react";
import EstimateCostDatabaseConfigration from "./EstimateCostDatabaseConfigration";
import EstimateSettings from "./EstimateGeneralSettings";
import { useTranslation } from "@i18n";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import type { EstimateCurrency } from "@ServerTypes/estimates/estimates.schema";

type CurrencyData = EstimateCurrency;

const EstimateConfigration = ({ currencyData }: { currencyData: CurrencyData }) => {
  const [currentSelectedSetting, setCurrentSelectedSetting] = useState("general");
  const { t } = useTranslation();
  return (
    <div className="flex w-full h-full overflow-auto">
      <div className="w-72 flex-none h-full p-4 border-0 border-e border-button_light">
        <div className="w-full">
          <ButtonComponent
            buttonType={BUTTON_TYPES.TEXT_BUTTON}
            className={`p-3 rounded text-base font-semibold w-full flex justify-start ${currentSelectedSetting == "general" && "bg-selection"}`}
            onClick={() => {
              setCurrentSelectedSetting("general");
            }}
          >
            {t("Preferences")}
          </ButtonComponent>
        </div>
        <div className="w-full">
          <ButtonComponent
            buttonType={BUTTON_TYPES.TEXT_BUTTON}
            className={`p-3 rounded text-base font-semibold w-full flex justify-start ${
              currentSelectedSetting == "costDatabase" && "bg-selection"
            }`}
            onClick={() => {
              setCurrentSelectedSetting("costDatabase");
            }}
          >
            {t("Cost Database")}
          </ButtonComponent>
        </div>
      </div>
      {currentSelectedSetting == "costDatabase" ? (
        <EstimateCostDatabaseConfigration currencyData={currencyData} />
      ) : (
        <EstimateSettings />
      )}
    </div>
  );
};

export default EstimateConfigration;
